<div
  ngbDropdown
  #dropDownPicker
  class="d-inline-block w-100"
  [container]="'body'"
  [style]="disabled ? 'pointer-events: none;' : ''"
>
  <div class="input-group">
    <input
      class="form-control form-control-sm"
      name="inputDate"
      readonly
      [(ngModel)]="dateTime"
      [disabled]="disabled"
      ngbDropdownToggle
    />

    <div class="dtp-icons" *ngIf="showCalendarIconButton">
    <button
      type="button"
      class="btn btn-link dtp-icon-btn"
      [disabled]="disabled"
      ngbDropdownToggle
      aria-label="Open date picker"
      title="{{ '::SelectDate' | abpLocalization }}"
    >
      <i class="fa-regular fa-calendar"></i>
    </button>

    <button
      type="button"
      class="btn btn-link dtp-icon-btn dtp-clear-btn"
      [disabled]="disabled"
      (click)="resetValue(); $event.stopPropagation()"
      aria-label="Clear date"
      title="{{ '::Clear' | abpLocalization }}"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

    <div class="input-group-append">
      <button *ngIf="allowNull && !doNotDisplayClearButton" class="btn btn-link" (click)="resetValue()" type="button" [disabled]="disabled">
        {{ '::Clear' | abpLocalization }}
      </button>
    </div>
  </div>
  <div ngbDropdownMenu aria-labelledby="inputDate">
    <div class="row main">
      <div class="col-12">
        <div class="row m-1 {{ isRTL ? 'rtl-datepicker' : '' }}">
          <ngb-datepicker
            #dtp
            id="dtp"
            [maxDate]="formatedMaxDate"
            [minDate]="formatedMinDate"
            (dateSelect)="onDateSelect($event)"
            name="dtp"
            class="picker"
            [(ngModel)]="ngbDateModel"
            [disabled]="disabled"
          ></ngb-datepicker>
        </div>
        <div class="row justify-content-center pt-3" *ngIf="showTime">
          <ngb-timepicker
            name="time"
            [(ngModel)]="ngbTime"
            (change)="onTimeChange($event)"
            [spinners]="false"
          ></ngb-timepicker>
        </div>
      </div>
    </div>
  </div>
</div>
